module.exports = __webpack_public_path__ + "static/media/icon_check.cce5058c.svg";